import { render } from "./Tree.vue?vue&type=template&id=2b8e1cdd"
import script from "./Tree.vue?vue&type=script&lang=js"
export * from "./Tree.vue?vue&type=script&lang=js"
script.render = render

export default script